export { SocialMediaWallTemplate } from "../../partial-templates/social-media-wall/social-media-wall.templates";
